export default __webpack_public_path__ + "static/media/hands.cb1952eb.svg";